module.exports = __webpack_public_path__ + "static/media/siddharth-bannerghatta-zoo-trip-01.77d39870.png";